import {createSelector} from "reselect";

const selectMainMap = state => state.map;

export const selectMap = createSelector(
    [selectMainMap],
    map => map.map
);

export const selectMyLocationArr = createSelector(
    [selectMainMap],
    map => map.myLocation
);

export const selectIconsLayer = createSelector(
    [selectMainMap],
    map => map.iconLayers
);
export const selectReportLayer = createSelector(
    [selectMainMap],
    map => map.reportLayer
);
export const selectIsMain = createSelector(
    [selectMainMap],
    map => map.isMain
);
export const selectIsLive = createSelector(
    [selectMainMap],
    map => map.isLive
);
export const selectCounter = createSelector(
    [selectMainMap],
    map => map.counter
);
export const selectTimer = createSelector(
    [selectMainMap],
    map => map.timer
);
export const selectMountLiveTime = createSelector(
    [selectMainMap],
    map => map.MountLiveTime
);
export const selectRefresher = createSelector(
    [selectMainMap],
    map => map.refresher
);
export const selectRefresherTime = createSelector(
    [selectMainMap],
    map => map.refreshTime
);
export const selectLivePath = createSelector(
    [selectMainMap],
    map => map.path
);
